import { takeEvery } from 'redux-saga/effects';

import * as phoneActionTypes from 'store/modules/phone/actionTypes';

import { clearPhoneNumber } from './utils';

export default function* listenClearPhoneNumber() {
  yield takeEvery(phoneActionTypes.CLEAR_PHONE_NUMBER, clearPhoneNumber);
}
